import {
  isImageInsideObstacle,
  isPositionFree,
  canPlaceImage,
} from "../canvasFunction";
import { updateRoofInfo } from "../../../../Features/roofInfo";
import { updateRoofDetails } from "../../../../Features/quantityInfo";
import { panelInformation } from "../../../DataFiles/panelInformation";
import { generationLosses } from "../../Functions/generationCalculate";
import { getPixelsPerMeter } from "./smithStructure";

export const doubleCarportPlacement = ({
  roofDetail,
  roofInfo,
  structureItem,
  dispatch,
  abstacles,
  gridInfo,
  limitCapacity,
  quantityInfo,
}) => {
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  sessionStorage.setItem("structureItem", JSON.stringify(structureItem));

  let pixelMultiple = getPixelsPerMeter(roofInfo);

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const imgSrc = structureItem.structureImgSrc;
  const imgDimension = {
    height: (2 * panel.height + 0.025) * pixelMultiple,
    width: (4 * panel.width + 0.025) * pixelMultiple,
  };

  const newImages = [];
  const polygonCoordinates = roofPolygons[quantityInfo.roofNo].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x + 0,
    point.y + 0,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const unitValue = gridInfo.unit === "m" ? 1 : 0.305;
  const roadSpace = roofDetail.roadSpace * pixelMultiple * unitValue;
  const angleDegrees = 0;
  let x = minX + roadSpace;
  let y = minY + roadSpace;

  let row = 0;
  let isFirstRowPlaced = false;
  let updateCondition = true;
  while (y <= maxY - roadSpace - imgDimension.height) {
    while (x <= maxX - roadSpace - imgDimension.width) {
      if (limitCapacity !== 0 && newImages.length > limitCapacity) {
        updateCondition = false;
      }
      if (
        updateCondition &&
        canPlaceImage(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isPositionFree(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          newImages
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          abstacles
        )
      ) {
        const imageId =
          Number(Math.floor(Math.random() * 499)) *
          Number(Math.floor(Math.random() * 499));
        const newImage = {
          id: imageId,
          src: imgSrc,
          x: x,
          y: y,
          width: imgDimension.width,
          height: imgDimension.height,
          type: structureItem.name,
          angleDegree: 0,
        };
        newImages.push(newImage);
        x += imgDimension.width;
      } else {
        x += imgDimension.width;
      }
    }
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      if (row % 2 === 0) {
        y += imgDimension.height + roadSpace;
      } else {
        y += imgDimension.height;
      }
    }
    row++;
    x = minX + roadSpace;
  }

  calculateCarportStructure({
    newImages,
    structureItem,
    dispatch,
    roofDetail,
    quantityInfo,
    roofInfo,
  });

  dispatch(updateRoofInfo({ selectionType: "Single" }));
};

export const calculateCarportStructure = ({
  newImages,
  structureItem,
  dispatch,
  roofDetail,
  quantityInfo,
  roofInfo,
}) => {
  const customDetail = {
    beam: 0,
    polls: 0,
    rail: 0,
    endClamp: 0,
    midClamp: 0,
  };
  let col = 0;
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const lastImage = newImages[newImages.length - 1];

  for (let i = 0; i < newImages.length; i++) {
    const element = newImages[i];
    if (element.id === newImages[0].id) {
      col++;
      customDetail.endClamp += 4;
    } else if (
      (element.x - newImages[i - 1].x).toFixed(2) === element.width.toFixed(2)
    ) {
      col++;
      if (element.id === lastImage.id) {
        const block = col;
        customDetail.beam += block + 1;
        customDetail.polls += 3 * (block + 1);
        customDetail.rail +=
          4 * (col * (4 * panel.width + 0.075) * 3.28084 + 100 / 304.8);
        customDetail.midClamp += block * 16 - 4;
        customDetail.endClamp += 4;
      }
    } else if (
      (element.x - newImages[i - 1].x).toFixed(2) !== element.width.toFixed(2)
    ) {
      const block = col;
      customDetail.beam += block + 1;
      customDetail.polls += 3 * (block + 1);
      customDetail.rail +=
        4 * (col * (4 * panel.width + 0.075) * 3.28084 + 100 / 304.8);
      customDetail.endClamp += 8;

      customDetail.midClamp += block * 16 - 4;
      col = 1;
      if (element.id === lastImage.id) {
        customDetail.endClamp += 4;
        customDetail.midClamp += 12;
      }
    }
  }
  const totalKilowatt = Number(
    (newImages.length * 8 * (panel.pMax / 1000)).toFixed(1)
  );

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;
  const azimuth =
    roofDetail.customCapacityType === "Auto" ? 180 : roofDetail.azimuth;

  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: totalKilowatt,
    customCapacity: totalKilowatt,
    totalStructure: "--",
    pvModule: newImages.length * 8,
    endClamp: customDetail.endClamp,
    midClamp: customDetail.midClamp,
    price: structureItem.price,
    mountingStructure: structureItem.name,
    railLength: customDetail.rail,
    walkWayLength: 0,
    beam: customDetail.beam,
    polls: customDetail.polls,
    rails: 0,
    azimuth: azimuth,
    rowDistance: rowDistance,
    multipleStructure: [],
  };

  console.log(myObject);
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );

  const value = { ...roofDetail, ...myObject };
  generationLosses( value, quantityInfo, dispatch);
};
